import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { PAGE_CREATE_CONTENT } from '../../constants/UriConstants';
import PageHeader from '../PageHeader';
import Button from '../common/Button';

const DiscoveryContentTopBar = () => {
  const navigate = useNavigate();
  const handleAddContent = useCallback(() => {
    navigate(`/${PAGE_CREATE_CONTENT}`);
  }, [navigate]);

  return (
    <PageHeader title="DISCOVERY">
      <Button className="page-header__action-button" onClick={handleAddContent}>
        ADD CONTENT
      </Button>
    </PageHeader>
  );
};

export default DiscoveryContentTopBar;
